import { css } from '@emotion/react';

export const merchantProfileGrid = css`
  margin-bottom: 32px;
`;
